module.exports = __webpack_public_path__ + "fonts/proximanova-light-webfont.07cf5f42.woff";